/**
 * Environment-based logging utility
 * Only logs to console when REACT_APP_NODE_ENV or NODE_ENV is 'development'
 */

const isDevelopment =
  process.env.REACT_APP_NODE_ENV === 'development'

/**
 * Logs a message to console only in development environment
 * @param {string} message - The message to log
 * @param {any} data - Optional data to log
 */
export const log = (message, data) => {
  if (isDevelopment) {
    if (data !== undefined) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  }
};

/**
 * Logs an error to console only in development environment
 * @param {string} message - The error message to log
 * @param {any} error - Optional error object to log
 */
export const logError = (message, error) => {
  if (isDevelopment) {
    if (error !== undefined) {
      console.error(message, error);
    } else {
      console.error(message);
    }
  }
};

/**
 * Logs a warning to console only in development environment
 * @param {string} message - The warning message to log
 * @param {any} data - Optional data to log
 */
export const logWarn = (message, data) => {
  if (isDevelopment) {
    if (data !== undefined) {
      console.warn(message, data);
    } else {
      console.warn(message);
    }
  }
};

/**
 * Checks if the current environment is development
 * @returns {boolean} True if development, false otherwise
 */
export const isDev = () => isDevelopment;
